module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapComponent"
  }, [_c('analytics', {
    class: {
      show: !_vm.showAnalytics
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "navbar "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    attrs: {
      "id": "navMenubd-example"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('navbar.projects')))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable userProfile"
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('span', {
    staticClass: "icon user",
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.userName) + "\n              "), _c('i', {
    staticClass: "fa fa-user"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_c('a', {
    staticClass: "navbar-item logout"
  }, [_vm._v(_vm._s(_vm.$t('navbar.logout')))])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "map",
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('nav', {
    staticClass: "panel mainpanel",
    class: {
      active: _vm.isActive
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "icon menuicon",
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive;
        _vm.showHide()
      }
    }
  }, [_c('div', {
    staticClass: "layers"
  })]), _vm._v(" "), (_vm.sensors.length > 0) ? _c('span', {
    staticClass: "icon menuicon is-medium charticon",
    on: {
      "click": function($event) {
        _vm.showAnalytics = !_vm.showAnalytics
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.docs.length > 0) ? _c('span', {
    staticClass: "icon menuicon is-medium charticon",
    on: {
      "click": function($event) {
        _vm.showAnalytics = !_vm.showAnalytics
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('nav', {
    staticClass: "panel layerpanel",
    class: {
      active: !_vm.isActive
    }
  }, [_c('div', {
    staticClass: "toggleLayerPanel",
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('leftPanel.back')))])]), _vm._v(" "), _c('collapse', {
    attrs: {
      "is-fullwidth": ""
    }
  }, [(_vm.ortophoto.length > 0) ? _c('collapse-item', {
    attrs: {
      "title": _vm.$t('leftPanel.ortophoto')
    }
  }, [_c('ul', _vm._l((_vm.ortophoto), function(orto) {
    return _c('li', [_c('div', {
      staticClass: "layerCell"
    }, [_c('label', {
      staticClass: "panel-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.layersOn),
        expression: "layersOn"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": orto.id,
        "checked": Array.isArray(_vm.layersOn) ? _vm._i(_vm.layersOn, orto.id) > -1 : (_vm.layersOn)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.layersOn,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = orto.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.layersOn = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.layersOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.layersOn = $$c
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.zoomTo(orto.id)
        }
      }
    }, [_vm._v(_vm._s(orto.name))])]), _vm._v(" "), _c('span', {
      staticClass: "icon infoicon is-small"
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.isVisible = !_vm.isVisible, _vm.showLayerInfoPanel(orto.id)
        }
      }
    })])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.layers.length > 0) ? _c('collapse-item', {
    attrs: {
      "title": _vm.$t('leftPanel.layers')
    }
  }, [_c('ul', _vm._l((_vm.layers), function(layer) {
    return _c('li', [_c('div', {
      staticClass: "layerCell"
    }, [_c('label', {
      staticClass: "panel-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.layersOn),
        expression: "layersOn"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": layer.id,
        "checked": Array.isArray(_vm.layersOn) ? _vm._i(_vm.layersOn, layer.id) > -1 : (_vm.layersOn)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.layersOn,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = layer.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.layersOn = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.layersOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.layersOn = $$c
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.zoomTo(layer.id)
        }
      }
    }, [_vm._v(_vm._s(layer.name))])]), _vm._v(" "), _c('span', {
      staticClass: "icon infoicon is-small"
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.isVisible = !_vm.isVisible, _vm.showLayerInfoPanel(layer.id)
        }
      }
    })])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.sensors.length > 0) ? _c('collapse-item', {
    attrs: {
      "title": _vm.$t('leftPanel.sensors')
    }
  }, [_c('ul', _vm._l((_vm.sensors), function(sensor) {
    return _c('li', [_c('div', {
      staticClass: "layerCell"
    }, [_c('label', {
      staticClass: "panel-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.sensorsOn),
        expression: "sensorsOn"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": sensor.id,
        "checked": Array.isArray(_vm.sensorsOn) ? _vm._i(_vm.sensorsOn, sensor.id) > -1 : (_vm.sensorsOn)
      },
      on: {
        "change": _vm.addSensorToMap,
        "__c": function($event) {
          var $$a = _vm.sensorsOn,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = sensor.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.sensorsOn = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.sensorsOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.sensorsOn = $$c
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.zoomTo(sensor.id)
        }
      }
    }, [_vm._v(_vm._s(sensor.label))])]), _vm._v(" "), _c('span', {
      staticClass: "icon infoicon is-small"
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.isVisible = !_vm.isVisible, _vm.showLayerInfoPanel(sensor.id)
        }
      }
    })])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.scenes.length > 0) ? _c('collapse-item', {
    attrs: {
      "title": _vm.$t('leftPanel.scenes')
    }
  }, [_c('ul', _vm._l((_vm.scenes), function(scene) {
    return _c('li', [_c('div', {
      staticClass: "layerCell"
    }, [_c('label', {
      staticClass: "panel-block"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": scene.sceneUrl
      }
    }, [_vm._v(_vm._s(scene.label))])])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.markers.length > 0) ? _c('collapse-item', {
    attrs: {
      "title": _vm.$t('leftPanel.markers')
    }
  }, [_c('ul', _vm._l((_vm.markers), function(marker, index, key) {
    return _c('li', [_c('div', {
      staticClass: "markerCell"
    }, [_c('label', {
      staticClass: "panel-block"
    }, [_c('span', {
      staticClass: "icon is-small",
      on: {
        "click": function($event) {
          _vm.mapOnClick(_vm.addMarkerToMap)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../static/img/marker.svg"),
        "alt": "map-marker"
      }
    })]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.zoomTo(marker)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('leftPanel.point')) + " " + _vm._s(index))]), _vm._v(" "), _c('a', {
      staticClass: "button is-info",
      on: {
        "click": function($event) {
          _vm.addNoteToMarker(marker)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('leftPanel.note')))])]), _vm._v(" "), _c('span', {
      staticClass: "icon removeMarkerIcon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeMarkerFromMap(marker)
        }
      }
    })]), _vm._v(" "), _c('quill-editor', {
      ref: "myQuillEditor",
      refInFor: true,
      class: marker,
      attrs: {
        "options": _vm.editorOption
      },
      on: {
        "change": function($event) {
          _vm.sendNote($event, marker)
        }
      },
      model: {
        value: (_vm.noteContent[marker]),
        callback: function($$v) {
          _vm.$set(_vm.noteContent, marker, $$v)
        },
        expression: "noteContent[marker]"
      }
    })], 1)])
  }))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns pane"
  }, [_c('div', {
    staticClass: "column is-2 layerInfoPanel",
    class: {
      visible: !_vm.isVisible
    }
  }, [_c('div', {
    staticClass: "upperPanel"
  }, [_c('figure', {
    staticClass: "image is-138x138"
  }, [_c('img', {
    attrs: {
      "src": _vm.layerInfo.imgThumbnailUrl
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.layerInfo.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "lowerPanel"
  }, [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('rightPanel.layer')) + ": ")]), _vm._v(" " + _vm._s(_vm.layerInfo.name))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('rightPanel.project')) + ": ")]), _vm._v(" " + _vm._s(_vm.layerInfo.projectName))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('rightPanel.date')) + ": ")]), _vm._v(" " + _vm._s(_vm.layerInfo.timestamp))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDownLink),
      expression: "isDownLink"
    }],
    staticClass: "downloadButton button is-primary",
    attrs: {
      "href": _vm.downLink
    }
  }, [_vm._v(_vm._s(_vm.$t('rightPanel.download')))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isScene),
      expression: "isScene"
    }],
    staticClass: "downloadButton button is-info",
    attrs: {
      "target": "_blank",
      "href": _vm.sceneUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('rightPanel.scene')))]), _vm._v(" "), _c('div', {
    staticClass: "togglePanel",
    on: {
      "click": function($event) {
        _vm.isVisible = !_vm.isVisible
      }
    }
  }, [_vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item"
  }, [_c('img', {
    attrs: {
      "src": "https://staticcontentskymaps.blob.core.windows.net/static/static/logo_v2.png",
      "alt": "Skymaps"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    attrs: {
      "data-target": "navMenubd-example"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "icon menuicon is-medium"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon togglePanelIcon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0420ceb0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 212
// module chunks = 1